import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../features/userSlice';

import clsx from 'clsx';
import { createTheme } from '@material-ui/core/styles';
import * as colors from '@material-ui/core/colors';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';

import Modal from '@material-ui/core/Modal'; // kamome

//
import HomeIcon from '@material-ui/icons/Home';

import OpenInNewIcon from '@material-ui/icons/OpenInNew'; // 外部リンク用

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// ★ ここからメニュー用アイコン
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import ViewListIcon from '@material-ui/icons/ViewList';
import MapIcon from '@material-ui/icons/Map';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ShareIcon from '@material-ui/icons/Share';
import TimelineIcon from '@material-ui/icons/Timeline';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import GavelIcon from '@material-ui/icons/Gavel';
import BugReportIcon from '@material-ui/icons/BugReport';
import StarsIcon from '@material-ui/icons/Stars';
import PhotoFilterIcon from '@material-ui/icons/PhotoFilter';
import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import PostAddIcon from '@material-ui/icons/PostAdd';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';

// 高度メニュー用
import BuildIcon from '@material-ui/icons/Build';
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';

import SettingsIcon from '@material-ui/icons/Settings'; // トグル用にだけ残す

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
//

// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';

// import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
// import CollectionsIcon from '@material-ui/icons/Collections';

import Collapse from '@material-ui/core/Collapse';
import ListSubheader from '@material-ui/core/ListSubheader';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import Avatar from '@mui/material/Avatar';

import { AdminAppBar } from './AdminAppBar';

import { auth } from '../../firebase';

import { XROSS_ENV } from '../../xross.config.js';

import styles from './Template.module.css';

const drawerWidth = 240;

const theme = createTheme({
  typography: {
    fontFamily: [
      'Noto Sans JP',
      'Lato',
      '游ゴシック Medium',
      '游ゴシック体',
      'Yu Gothic Medium',
      'YuGothic',
      'ヒラギノ角ゴ ProN',
      'Hiragino Kaku Gothic ProN',
      'メイリオ',
      'Meiryo',
      'ＭＳ Ｐゴシック',
      'MS PGothic',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: { main: colors.green[800] }, // テーマの色
  },
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    toolbar: {
      paddingRight: 24,
    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: 'none',
    },
    title: {
      flexGrow: 1,
    },
    pageTitle: {
      marginBottom: theme.spacing(1),
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    link: {
      textDecoration: 'none',
      color: theme.palette.text.secondary,
    },
    modal: {
      outline: 'none',
      position: 'absolute',
      width: 400,
      borderRadius: 10,
      backgroundColor: 'white',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(10),
    },
  }),
);

// ====== ここからメニュー定義を集約 ======

type StaticLinkItem = {
  label: string;
  url: string;
  description?: string;
  id?: string;
  pw?: string;
};

type NavItem = {
  id?: string; // 🔴 ここをオプショナルに
  to: string;
  label: string;
  icon: React.ElementType;
};

type AdvancedNavGroup = {
  title: string;
  items: NavItem[];
};

// 外部リンク（静的）
const STATIC_LINKS: StaticLinkItem[] = [
  {
    label: '開発環境',
    url: 'https://dev-moon-xross-club.netlify.app/',
    description: 'xross.club 開発用管理画面',
  },
  {
    label: 'ステージング環境',
    url: 'https://staging-moon-xross-club.netlify.app/',
    description: 'リリース前の検証用環境',
  },
  {
    label: '本番環境',
    url: 'https://prod-moon-xross-club.netlify.app/',
    description: '現在公開されている本番管理画面',
  },
  {
    label: '問い合わせメール',
    description: 'Web メール（sakura secure）',
    id: 'support@xross.club',
    pw: '猫p#123',
    url: 'https://secure.sakura.ad.jp/rs/mail/?v=2',
  },
];

// メインメニュー
const MAIN_MENU_ITEMS: NavItem[] = [
  {
    id: 'home',
    to: '/',
    label: 'トップページ',
    icon: HomeIcon,
  },
  {
    id: 'users',
    to: '/UserList',
    label: 'ユーザ一覧',
    icon: PeopleAltIcon,
  },
  {
    id: 'posts',
    to: '/PostCollection',
    label: '投稿一覧',
    icon: ViewListIcon, // 一覧＝リスト
  },
  {
    id: 'map',
    to: '/MapPage',
    label: '投稿一覧（地図）',
    icon: MapIcon, // 地図
  },
  {
    id: 'info',
    to: '/InfoPage',
    label: 'お知らせ',
    icon: NotificationsActiveIcon, // 通知・お知らせ
  },
  {
    id: 'share',
    to: '/ShereFeed',
    label: 'SNS共有ページ',
    icon: ShareIcon, // 共有
  },
  {
    id: 'service',
    to: '/ServiceState',
    label: 'サービス状態',
    icon: TimelineIcon, // 状態・モニタリング感
  },
  {
    id: 'inquiry',
    to: '/Inquiry',
    label: '問い合わせ管理',
    icon: ContactMailIcon, // メール＋問い合わせ
  },
  {
    id: 'report',
    to: '/Report',
    label: '報告（通報）管理',
    icon: ReportProblemIcon, // 通報
  },
  {
    id: 'ngword',
    to: '/NgWord',
    label: 'NGワード設定',
    icon: GavelIcon, // モデレーション・ルール
  },
  {
    id: 'ngword-checker',
    to: '/ngwords/checker',
    label: 'NGワードチェッカー',
    icon: CheckCircleIcon,
  },
  {
    id: 'functionlog',
    to: '/FunctionLog',
    label: 'FunctionLog',
    icon: BugReportIcon, // ログ・デバッグ
  },
  {
    id: 'premium',
    to: '/PremiumSettings',
    label: 'プレミアム設定',
    icon: StarsIcon, // プレミアム・★
  },
  {
    id: 'avatar-frame',
    to: '/AvatarFrameGroupList',
    label: 'アバターフレームの管理',
    icon: PhotoFilterIcon, // フィルター・フレーム感
  },
  {
    id: 'stamp',
    to: '/Default',
    label: 'スタンプの登録',
    icon: EmojiEmotionsIcon, // 顔スタンプ
  },
  {
    id: 'coupon',
    to: '/Default',
    label: 'クーポンの管理',
    icon: CardGiftcardIcon, // クーポン・ギフト券
  },
  {
    id: 'xrviewer-authoring',
    to: '/XRViewerAuthoring',
    label: 'XRViewer オーサリング',
    icon: ThreeDRotationIcon,
  },
  {
    id: 'create-post',
    to: '/CreatePost',
    label: '新規投稿',
    icon: PostAddIcon, // 投稿追加
  },
];

// 高度メニュー（管理者向け）
const ADVANCED_GROUPS: AdvancedNavGroup[] = [
  {
    title: '＜システム設定＞',
    items: [
      {
        to: '/RefreshPostsData',
        label: '投稿データのリフレッシュ',
        icon: BuildIcon, // 運用・メンテナンス
      },
    ],
  },
  {
    title: '＜システムテスト用＞',
    items: [
      {
        to: '/EntrySystemTestData',
        label: 'システムテスト用データの投入',
        icon: BuildOutlinedIcon, // テスト用の設定
      },
    ],
  },
  {
    title: '＜テストデータ投入＞',
    items: [
      {
        to: '/EntryTestData',
        label: '単体テスト用テストデータの投入',
        icon: PlaylistAddIcon, // データを追加していくイメージ
      },
    ],
  },
];

// ====== ここまでメニュー定義 ======

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      {new Date().getFullYear()}
      {'.'}
      <Link color="inherit" to="/">
        xross.club
      </Link>{' '}
    </Typography>
  );
};

// モーダルカードの表示関数（ログアウト用）
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

export interface GenericTemplateProps {
  children: React.ReactNode;
  title: string;
}

const GenericTemplate: React.FC<GenericTemplateProps> = ({
  children,
  title,
}) => {
  const classes = useStyles();

  // redux でログインユーザの管理を行う
  const user = useSelector(selectUser);

  const [open, setOpen] = React.useState(true);
  const [openModal, setOpenModal] = useState(false); // 初期値はモーダルが閉じている状態

  // 高度メニューの開閉と、誰に見せるかの判定
  const canSeeAdvanced =
    (user as any)?.role === 'admin' || user?.email?.endsWith('@piyamaru.com');

  const saved = localStorage.getItem('moon.showAdvanced');
  const [showAdvanced, setShowAdvanced] = useState<boolean>(
    saved === null ? false : saved === 'true',
  );

  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const next = !prev;
      localStorage.setItem('moon.showAdvanced', String(next));
      return next;
    });
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <CssBaseline />

        <AdminAppBar
          title={title}
          env={XROSS_ENV}
          user={{
            displayName: user?.displayName ?? null,
            email: user?.email ?? null,
            photoUrl: user?.photoUrl ?? null,
          }}
          drawerOpen={open}
          onOpenDrawer={handleDrawerOpen}
          onAvatarClick={() => setOpenModal(true)}
        />

        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />

          {/* メインメニュー */}
          <List>
            {MAIN_MENU_ITEMS.map((item) => (
              <Link key={item.id} to={item.to} className={classes.link}>
                <ListItem button>
                  <ListItemIcon>
                    <item.icon />
                  </ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItem>
              </Link>
            ))}
          </List>

          {/* 外部リンクセクション */}
          <Divider />
          <ListSubheader component="div" inset>
            外部リンク
          </ListSubheader>
          <List>
            {STATIC_LINKS.map((item) => {
              const secondaryText = (
                <>
                  {item.description && <div>{item.description}</div>}
                  {item.id && <div>ID：{item.id}</div>}
                  {item.pw && <div>PW：{item.pw}</div>}
                </>
              );

              return (
                <ListItem
                  key={item.url}
                  button
                  component="a"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ListItemIcon>
                    <OpenInNewIcon />
                  </ListItemIcon>

                  <ListItemText
                    primary={item.label}
                    secondary={secondaryText}
                  />
                </ListItem>
              );
            })}
          </List>

          {/* 管理メニュー（高度メニューのトグル＋中身） */}
          {canSeeAdvanced && (
            <>
              <Divider />
              <ListSubheader component="div" inset>
                開発メニュー
              </ListSubheader>
              <List>
                <ListItem button onClick={toggleAdvanced}>
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary={showAdvanced ? '隠す' : '表示'} />
                  {showAdvanced ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              </List>

              <Collapse in={showAdvanced} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {ADVANCED_GROUPS.map((group) => (
                    <React.Fragment key={group.title}>
                      <div>
                        <hr />
                        {group.title}
                        <hr />
                      </div>
                      {group.items.map((item) => (
                        <Link
                          key={item.to}
                          to={item.to}
                          className={classes.link}
                        >
                          <ListItem button>
                            <ListItemIcon>
                              <item.icon />
                            </ListItemIcon>
                            <ListItemText primary={item.label} />
                          </ListItem>
                        </Link>
                      ))}
                    </React.Fragment>
                  ))}
                </List>
              </Collapse>
            </>
          )}
        </Drawer>

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="xl" className={classes.container}>
            <Typography
              component="h2"
              variant="h5"
              color="inherit"
              noWrap
              className={classes.pageTitle}
            >
              {title}
            </Typography>
            {children}
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <div style={getModalStyle()} className={classes.modal}>
          <div className={styles.login_modal}>
            ログアウトにゃ！
            <IconButton
              onClick={async () => {
                await auth.signOut();
              }}
            >
              <ExitToAppIcon />
            </IconButton>
          </div>
        </div>
      </Modal>
    </ThemeProvider>
  );
};

export default GenericTemplate;

// import React, { useState } from 'react';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../../features/userSlice';

// import clsx from 'clsx';
// import { createTheme } from '@material-ui/core/styles';
// import * as colors from '@material-ui/core/colors';
// import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
// import CssBaseline from '@material-ui/core/CssBaseline';
// import Drawer from '@material-ui/core/Drawer';
// import Box from '@material-ui/core/Box';
// import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
// import List from '@material-ui/core/List';
// import Typography from '@material-ui/core/Typography';
// import Divider from '@material-ui/core/Divider';
// import Container from '@material-ui/core/Container';
// import { Link } from 'react-router-dom';
// import MenuIcon from '@material-ui/icons/Menu';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import IconButton from '@material-ui/core/IconButton';
// import HomeIcon from '@material-ui/icons/Home';

// import Modal from '@material-ui/core/Modal'; // kamome
// import OpenInNewIcon from '@material-ui/icons/OpenInNew'; // ★ 追加：外部リンク用

// //import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemText from '@material-ui/core/ListItemText';

// import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
// import CollectionsIcon from '@material-ui/icons/Collections';
// //import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import SettingsIcon from '@material-ui/icons/Settings';

// import ExitToAppIcon from '@material-ui/icons/ExitToApp';

// import Collapse from '@material-ui/core/Collapse';
// import ListSubheader from '@material-ui/core/ListSubheader';
// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';

// //import { Avatar } from "@material-ui/core";
// import Avatar from '@mui/material/Avatar';
// //import Avatar from "@material-ui/core/Avatar";

// import { AdminAppBar } from './AdminAppBar';

// import { auth } from '../../firebase';

// import { XROSS_ENV } from '../../xross.config.js';

// import styles from './Template.module.css';

// const drawerWidth = 240;

// const theme = createTheme({
//   typography: {
//     fontFamily: [
//       'Noto Sans JP',
//       'Lato',
//       '游ゴシック Medium',
//       '游ゴシック体',
//       'Yu Gothic Medium',
//       'YuGothic',
//       'ヒラギノ角ゴ ProN',
//       'Hiragino Kaku Gothic ProN',
//       'メイリオ',
//       'Meiryo',
//       'ＭＳ Ｐゴシック',
//       'MS PGothic',
//       'sans-serif',
//     ].join(','),
//   },
//   palette: {
//     primary: { main: colors.green[800] }, // テーマの色
//   },
// });

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       display: 'flex',
//     },
//     toolbar: {
//       paddingRight: 24,
//     },
//     toolbarIcon: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'flex-end',
//       padding: '0 8px',
//       ...theme.mixins.toolbar,
//     },
//     appBar: {
//       zIndex: theme.zIndex.drawer + 1,
//       transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//       }),
//     },
//     appBarShift: {
//       marginLeft: drawerWidth,
//       width: `calc(100% - ${drawerWidth}px)`,
//       transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//     },
//     menuButton: {
//       marginRight: 36,
//     },
//     menuButtonHidden: {
//       display: 'none',
//     },
//     title: {
//       flexGrow: 1,
//     },
//     pageTitle: {
//       marginBottom: theme.spacing(1),
//     },
//     drawerPaper: {
//       position: 'relative',
//       whiteSpace: 'nowrap',
//       width: drawerWidth,
//       transition: theme.transitions.create('width', {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//     },
//     drawerPaperClose: {
//       overflowX: 'hidden',
//       transition: theme.transitions.create('width', {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//       }),
//       width: theme.spacing(7),
//       [theme.breakpoints.up('sm')]: {
//         width: theme.spacing(9),
//       },
//     },
//     appBarSpacer: theme.mixins.toolbar,
//     content: {
//       flexGrow: 1,
//       height: '100vh',
//       overflow: 'auto',
//     },
//     container: {
//       paddingTop: theme.spacing(4),
//       paddingBottom: theme.spacing(4),
//     },
//     paper: {
//       padding: theme.spacing(2),
//       display: 'flex',
//       overflow: 'auto',
//       flexDirection: 'column',
//     },
//     link: {
//       textDecoration: 'none',
//       color: theme.palette.text.secondary,
//     },
//     modal: {
//       outline: 'none',
//       position: 'absolute',
//       width: 400,
//       borderRadius: 10,
//       backgroundColor: 'white',
//       boxShadow: theme.shadows[5],
//       padding: theme.spacing(10),
//     },
//   })
// );

// // ★ 追加：外部静的リンク（必要に応じてここを書き換え）
// const STATIC_LINKS: Array<{
//   label: string;
//   url: string;
//   description?: string;
//   id?: string;
//   pw?: string;
// }> = [
//   { label: '開発環境', url: 'https://dev-moon-xross-club.netlify.app/' },
//   {
//     label: 'ステージング環境',
//     url: 'https://staging-moon-xross-club.netlify.app/',
//   },
//   {
//     label: '本番環境',
//     url: 'https://prod-moon-xross-club.netlify.app/',
//   },
//   {
//     label: '問い合わせメール',
//     description: 'Web メール（sakura secure）',
//     id: 'support@xross.club',
//     pw: '猫p#123',
//     url: 'https://secure.sakura.ad.jp/rs/mail/?v=2',
//   },
//   // 追加したければここに増やす
// ];

// const Copyright = () => {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       {'Copyright © '}
//       {new Date().getFullYear()}
//       {'.'}
//       <Link color="inherit" to="/">
//         xross.club
//       </Link>{' '}
//     </Typography>
//   );
// };

// // モーダルカードの表示関数
// // ログアウト用
// // kamome
// function getModalStyle() {
//   const top = 50;
//   const left = 50;

//   return {
//     top: `${top}%`,
//     left: `${left}%`,
//     transform: `translate(-${top}%, -${left}%)`,
//   };
// }

// export interface GenericTemplateProps {
//   children: React.ReactNode;
//   title: string;
// }

// const GenericTemplate: React.FC<GenericTemplateProps> = ({
//   children,
//   title,
// }) => {
//   const classes = useStyles();

//   // redux でログインユーザの管理を行う
//   const user = useSelector(selectUser);

//   const [open, setOpen] = React.useState(true);
//   const [openModal, setOpenModal] = useState(false); //初期値はモーダルが閉じている状態

//   // ここを追加：高度メニューの開閉と、誰に見せるかの判定
//   const canSeeAdvanced =
//     (user as any)?.role === 'admin' || user.email?.endsWith('@piyamaru.com');

//   const saved = localStorage.getItem('moon.showAdvanced');
//   const [showAdvanced, setShowAdvanced] = useState<boolean>(
//     saved === null ? false : saved === 'true'
//   );

//   const toggleAdvanced = () => {
//     setShowAdvanced((prev) => {
//       const next = !prev;
//       localStorage.setItem('moon.showAdvanced', String(next));
//       return next;
//     });
//   };

//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };
//   const handleDrawerClose = () => {
//     setOpen(false);
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <div className={classes.root}>
//         <CssBaseline />

//         <AdminAppBar
//           title={title}
//           env={XROSS_ENV}
//           user={{
//             displayName: user?.displayName ?? null,
//             email: user?.email ?? null,
//             photoUrl: user?.photoUrl ?? null,
//           }}
//           drawerOpen={open}
//           onOpenDrawer={handleDrawerOpen}
//           onAvatarClick={() => setOpenModal(true)}
//         />

//         <Drawer
//           variant="permanent"
//           classes={{
//             paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
//           }}
//           open={open}
//         >
//           <div className={classes.toolbarIcon}>
//             <IconButton onClick={handleDrawerClose}>
//               <ChevronLeftIcon />
//             </IconButton>
//           </div>
//           <Divider />
//           <List>
//             <Link to="/" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <HomeIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="トップページ" />
//               </ListItem>
//             </Link>

//             <Link to="/UserList" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <PeopleAltIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="ユーザ一覧" />
//               </ListItem>
//             </Link>

//             <Link to="/PostCollection" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <CollectionsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="投稿一覧" />
//                 <Link
//                   to="/PostCollection/SinglePostView"
//                   className={classes.link}
//                 ></Link>
//               </ListItem>
//             </Link>
//             <Link to="/MapPage" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <CollectionsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="投稿一覧（地図）" />
//                 <Link
//                   to="/PostCollection/SinglePostView"
//                   className={classes.link}
//                 ></Link>
//               </ListItem>
//             </Link>
//             <Link to="/InfoPage" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <PeopleAltIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="お知らせ" />
//               </ListItem>
//             </Link>
//             <Link to="/ShereFeed" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <CollectionsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="SNS共有ページ" />
//               </ListItem>
//             </Link>

//             <Link to="/ServiceState" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="サービス状態" />
//               </ListItem>
//             </Link>

//             <Link to="/Inquiry" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="問い合わせ管理" />
//               </ListItem>
//             </Link>

//             <Link to="/Report" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="報告（通報）管理" />
//               </ListItem>
//             </Link>

//             <Link to="/NgWord" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="NGワード設定" />
//               </ListItem>
//             </Link>

//             <Link to="/FunctionLog" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="FunctionLog" />
//               </ListItem>
//             </Link>

//             <Link to="/PremiumSettings" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="プレミアム設定" />
//               </ListItem>
//             </Link>

//             <Link to="/AvatarFrameGroupList" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="アバターフレームの管理" />
//               </ListItem>
//             </Link>

//             <Link to="/Default" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="スタンプの登録" />
//               </ListItem>
//             </Link>

//             <Link to="/Default" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="クーポンの管理" />
//               </ListItem>
//             </Link>
//           </List>

//           {/* ★ 追加：外部リンクセクション */}
//           <Divider />
//           <ListSubheader component="div" inset>
//             外部リンク
//           </ListSubheader>
//           <List>
//             {STATIC_LINKS.map((item) => {
//               const secondaryText = (
//                 <>
//                   {item.description && <div>{item.description}</div>}
//                   {item.id && <div>ID：{item.id}</div>}
//                   {item.pw && <div>PW：{item.pw}</div>}
//                 </>
//               );

//               return (
//                 <ListItem
//                   key={item.url}
//                   button
//                   component="a"
//                   href={item.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <ListItemIcon>
//                     <OpenInNewIcon />
//                   </ListItemIcon>

//                   <ListItemText
//                     primary={item.label}
//                     secondary={secondaryText}
//                   />
//                 </ListItem>
//               );
//             })}
//           </List>

//           {/* --- 高度メニューのトグル（管理者だけ表示） --- */}
//           {canSeeAdvanced && (
//             <>
//               <Divider />
//               <ListSubheader component="div" inset>
//                 管理メニュー
//               </ListSubheader>
//               <List>
//                 <ListItem button onClick={toggleAdvanced}>
//                   <ListItemIcon>
//                     <SettingsIcon />
//                   </ListItemIcon>
//                   <ListItemText primary={showAdvanced ? '隠す' : '表示'} />
//                   {showAdvanced ? <ExpandLess /> : <ExpandMore />}
//                 </ListItem>
//               </List>

//               {/* --- 高度メニュー本体（折りたたみ） --- */}
//               <Collapse in={showAdvanced} timeout="auto" unmountOnExit>
//                 <List component="div" disablePadding>
//                   <div>
//                     <hr />
//                     ＜システム設定＞
//                     <hr />
//                   </div>

//                   {/* <Link to="/SystemSetup" className={classes.link}>
//               <ListItem button>
//                 <ListItemIcon>
//                   <SettingsIcon />
//                 </ListItemIcon>
//                 <ListItemText primary="システム初期化" />
//               </ListItem>
//             </Link> */}

//                   <Link to="/RefreshPostsData" className={classes.link}>
//                     <ListItem button>
//                       <ListItemIcon>
//                         <SettingsIcon />
//                       </ListItemIcon>
//                       <ListItemText primary="投稿データのリフレッシュ" />
//                     </ListItem>
//                   </Link>
//                 </List>

//                 <div>
//                   <hr />
//                   ＜システムテスト用＞
//                   <hr />
//                 </div>
//                 <Link to="/EntrySystemTestData" className={classes.link}>
//                   <ListItem button>
//                     <ListItemIcon>
//                       <SettingsIcon />
//                     </ListItemIcon>
//                     <ListItemText primary="システムテスト用データの投入" />
//                   </ListItem>
//                 </Link>

//                 <div>
//                   <hr />
//                   ＜テストデータ投入＞
//                   <hr />
//                 </div>
//                 <Link to="/EntryTestData" className={classes.link}>
//                   <ListItem button>
//                     <ListItemIcon>
//                       <SettingsIcon />
//                     </ListItemIcon>
//                     <ListItemText primary="単体テスト用テストデータの投入" />
//                   </ListItem>
//                 </Link>
//                 <Link to="/CreatePost" className={classes.link}>
//                   <ListItem button>
//                     <ListItemIcon>
//                       <SettingsIcon />
//                     </ListItemIcon>
//                     <ListItemText primary="新規投稿" />
//                   </ListItem>
//                 </Link>
//               </Collapse>
//             </>
//           )}
//         </Drawer>

//         <main className={classes.content}>
//           <div className={classes.appBarSpacer} />
//           <Container maxWidth="xl" className={classes.container}>
//             <Typography
//               component="h2"
//               variant="h5"
//               color="inherit"
//               noWrap
//               className={classes.pageTitle}
//             >
//               {title}
//             </Typography>
//             {children}
//             <Box pt={4}>
//               <Copyright />
//             </Box>
//           </Container>
//         </main>
//       </div>

//       <Modal open={openModal} onClose={() => setOpenModal(false)}>
//         <div style={getModalStyle()} className={classes.modal}>
//           <div className={styles.login_modal}>
//             ログアウトにゃ！
//             <IconButton
//               onClick={async () => {
//                 await auth.signOut();
//               }}
//             >
//               <ExitToAppIcon />
//             </IconButton>
//           </div>
//         </div>
//       </Modal>
//     </ThemeProvider>
//   );
// };

// export default GenericTemplate;
